// src/pages/LandingPage.js
import '../App.css';
import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import Footer from "../components/Footer.js";
import { useLanguage } from "../context/LanguageContext.js"
import { Helmet } from "react-helmet";

const LandingPage = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [footerHeight, setFooterHeight] = useState(0);

  const { t } = useLanguage();
  
  // 🔧 Récupère la hauteur du header pour ajuster le padding top
  const [headerHeight, setHeaderHeight] = useState(0);
  
  useEffect(() => {
    const header = document.querySelector(".header");
    if (header) setHeaderHeight(header.offsetHeight);
  }, []);

  // ⏳ Petit délai pour afficher le loader (effet visuel)
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timer);
  }, []);

  // 🔥 Réveil du backend dès l'arrivée sur la LandingPage
  useEffect(() => {
    fetch("https://apiow-backend.onrender.com/api/health")
      .then(() => console.log("Backend réveillé"))
      .catch(() => console.log("Backend KO"));
  }, []);

  // 🟡 Affiche le loader tant que loading = true
   if (loading) {
    return (
      <div
        style={{
          marginTop: "40px",
          fontSize: "1rem",
          color: "#555",
          textAlign: "center",
          fontStyle: "italic",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px"
        }}
      >
        <span
          style={{
            display: "inline-block",
            animation: "rotateHourglass 1.2s linear infinite",
            fontSize: "1.4rem"
          }}
        >
          ⏳
        </span>
        {t("PleaseWaitWakeUp")}
      </div>
    );
  }

  return (
    // 🧱 Wrapper principal de la LandingPage
    <div className="background-wrapper">

      {/* 🔥 SEO : Helmet doit être ici */}
      <Helmet>
        {/* SEO de base */}
        <title>{t("LandingSEO_Title")}</title>
        <meta name="description" content={t("LandingSEO_Description")} />

        {/* Canonical */}
        <link rel="canonical" href="https://organizwk.com" />

        {/* Open Graph (Facebook, LinkedIn, WhatsApp) */}
        <meta property="og:title" content={t("LandingSEO_Title")} />
        <meta property="og:description" content={t("LandingSEO_Description")} />
        <meta property="og:image" content="/seo/organiZwk-seo-optim.png" />
        <meta property="og:url" content="https://organizwk.com" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("LandingSEO_Title")} />
        <meta name="twitter:description" content={t("LandingSEO_Description")} />
        <meta name="twitter:image" content="/seo/organiZwk-seo-optim.png" />

        {/* Langue */}
        <html lang="fr" />
        </Helmet>

        {/* 🧩 Grille 3 colonnes (gauche - centre - droite) */}
        <div
          style={{
            /*paddingTop: 0,
            paddingBottom: isMobile
              ? `${footerHeight + 10}px` 
              : `${footerHeight}px`,*/
            /*paddingTop: `${headerHeight + 10}px`,
            paddingBottom: isMobile ? `${footerHeight + 10}px` : `${footerHeight}px`,  */
            paddingTop: `${headerHeight}px`,
            paddingBottom: `${footerHeight}px`,
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 2fr 1fr",
            gap: "16px",
            /*padding: isMobile ? "16px" : "32px",*/
            paddingLeft: isMobile ? "16px" : "32px",
            paddingRight: isMobile ? "16px" : "32px",
            /*minHeight: "calc(100vh - 80px)",*/
            minHeight: "100vh",
            boxSizing: "border-box",
          }}
        >

        {/* Colonne gauche : rond média */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: isMobile ? "120px" : "180px",
              height: isMobile ? "120px" : "180px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#ddd",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Exemple image */}
            <img src="/cool-organization.jpg" style={{ width: "100%", height: "100%", objectFit: "cover" }} 
            /> 

            {/* Exemple vidéo */}
            {/* <video src="/videos/taVideo.mp4" autoPlay loop muted style={{ width: "100%", height: "100%", objectFit: "cover" }} /> */}
          </div>
        </div>

        {/* Colonne centrale */}
        <div
          style={{
            maxWidth: "700px",
            width: "100%",
            margin: "0 auto",
            placeSelf: "center", // 👈 centre réellement dans la grille
            textAlign: "center",
          }}       
        >
          <h1 style={{ fontSize: isMobile ? "1.6rem" : "2.2rem",
            whiteSpace: "pre-line",   // 👈 affiche les \n
            textAlign: "center",      // 👈 centre chaque ligne
            lineHeight: 1.2           // 👈 optionnel, plus joli
          }}
        >
          {t('LandingTitle')}
        </h1>

        <p style={{ fontSize: isMobile ? "0.9rem" : "1rem", lineHeight: 1.5 }}>
          {t('LandingDescription')}
        </p>

        {/* Boutons */}
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {/* CTA principal */}
          <button
            onClick={() => (window.location.href = "/creation")}
            style={{
              padding: "10px 18px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#3399FF",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
              fontSize: "0.95rem",
              minWidth: "200px",
            }}
          >
            {t('StartAdventure')}
          </button>

          {/* Connexion au groupe – style outlined bleu */}
          <button
            onClick={() => (window.location.href = "/connexion")}
            style={{
              padding: "10px 18px",
              borderRadius: "4px",
              border: "2px solid #3399FF",
              backgroundColor: "white",
              color: "#3399FF",
              fontWeight: "bold",
              fontSize: "0.95rem",
              cursor: "pointer",
              minWidth: "220px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#3399FF";
              e.target.style.color = "#fff";
              e.target.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#3399FF";
              e.target.style.transform = "scale(1)";
            }}
          >
            {t('ConnectToAGroup')}
          </button>
        </div>

        {/* Tip du jour en bas */}
        <div
          style={{
            backgroundColor: "#2f2f2f",
            color: "#fff",
            borderRadius: "6px",
            padding: "10px 12px",
            fontSize: "0.9rem",
            marginTop: "60px",
          }}
        >
          <div style={{ fontWeight: "bold", marginBottom: "4px" }}> 
            {t('TipTitle')}
            </div>
          <div>{t('TipContent')}</div>
        </div>
      </div>

      {/* Colonne droite (vide pour équilibrer) */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: isMobile ? "120px" : "180px",
            height: isMobile ? "120px" : "180px",
            borderRadius: "50%",
            overflow: "hidden",
            backgroundColor: "#ddd",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Exemple image */}
          <img src="/cool-organization.jpg" 
          style={{ width: "100%", height: "100%", objectFit: "cover" }} 
          /> 
            {/* Exemple vidéo */}
            {/* <video src="/videos/taVideo.mp4" autoPlay loop muted style={{ width: "100%", height: "100%", objectFit: "cover" }} /> */}
        </div>
      </div>
    </div>

    {/* 📌 Footer avec hauteur dynamique */}      
    <Footer
      onHeightChange={setFooterHeight}
      isMobile={isMobile}
    />
  </div>
  );
};

export default LandingPage;
